import * as React from "react";
import { observer } from "mobx-react"; 
import { IContextualMenuItem } from "office-ui-fabric-react/lib/ContextualMenu";
import { HostAppView } from "@twii/core-ui-fabric/lib/component/HostAppView";
import { IAppProps } from "@twii/core-ui/lib/component/IAppProps";
import { DashboardListContainer } from "@twii/bored-ui-fabric/lib/component/DashboardList";
import { DashboardListStore } from "../model/DashboardListStore";
import { getTheme } from "@uifabric/styling";
import { addDashboard } from "@twii/bored/lib/DashboardActions";
import { createCommandBarMenuItem } from "@twii/bored-ui-fabric/lib/component/DashboardMenuHelper";
import { createDashboardListMenu } from "@twii/bored-ui-fabric/lib/component/DashboardLayoutMenuHelper";
import { IOzoneAppProps } from "@twii/ozone/lib/common/component/IOzoneAppProps";
import { createUserProfileMenu } from "@twii/ozone/lib/user/component/UserProfileMenuHelper";

@observer
class DashboardListApp extends React.Component<IOzoneAppProps, any> {
    componentWillMount() {
        DashboardListStore.load();
    }
    get host() {
        return this.props.match.host;
    }
    get userProfile() {
        return this.props.match.userProfile;
    }
    render() {
        const items : IContextualMenuItem[] = [
            createCommandBarMenuItem(DashboardListStore)
        ];
        const farItems : IContextualMenuItem[] = [];
        const layoutItem = createDashboardListMenu(DashboardListStore);
        if(layoutItem) {
            farItems.push(layoutItem);
        };
        if(this.userProfile) {
            const userProfileItem = createUserProfileMenu(this.userProfile);
            farItems.push(userProfileItem);
        }
        return (
            <HostAppView host={this.host} commandBarProps={{ items: items, farItems: farItems }}>
                <DashboardListContainer dashboardList={DashboardListStore} host={this.host} />
            </HostAppView>
        );
    }
}

export { DashboardListApp, DashboardListApp as default }